/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerOrderDetLinkModel { 
    customerOrderDetId?: number;
    guid?: string;
    customerOrderId?: number;
    itemNumber?: string | null;
    description?: string | null;
    uOfM?: string | null;
    quantity?: number;
    notes?: string | null;
    linkInvTranDetId?: number | null;
    fulfillmentState?: number;
    fulfillmentOrdinal?: number;
}

